/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { Route } from 'react-router-dom';
import NotAuthorised from './not-authorised';
import { getInitiativeUsage, getLevelUserRoles } from '../selectors/initiative';
import { RouteInterface } from '../types/routes';
import { useOktaAuth } from '@okta/okta-react';
import Loader from '../components/loader';
import { useAppSelector } from '../reducers';
import { isRouteEnabled } from '../constants/routes';
import { AppRoute } from './AppRoute';

interface AuthRouteProps {
  showHeader?: boolean;
  route: RouteInterface;
  authRequired?: boolean;
  path: string;
  exact: boolean;
  id: string;
}

export const AuthRoute = (props: AuthRouteProps) => {
  const { authRequired, route, showHeader = false, ...rest } = props;
  const { oktaAuth, authState } = useOktaAuth();

  const initiativeState = useAppSelector((state) => state.initiative);
  const userLevelRoles = useAppSelector(getLevelUserRoles);
  const initiativeUsage = useAppSelector(getInitiativeUsage);

  return <Route {...rest} render={(routeProps) => {
    if (authRequired && !authState?.isAuthenticated) {
      oktaAuth.signInWithRedirect()
      return <Loader />; // Loading... so it doesn't fall back to <Route component={NotFound} />
    }

    if (route.requiresInitiativeId) {
      if (!initiativeState.loaded) {
        return <Loader />;
      }

      const [, userPerm] = isRouteEnabled(route, userLevelRoles, initiativeUsage);
      if (!userPerm || initiativeState.errored) {
        return <NotAuthorised />;
      }
    }

    return <AppRoute {...routeProps} route={route} showHeader={showHeader} />;
  }} />;
}
